class DocumentationPublish {

    constructor() {

        // Plantillas
        this._template = null;
        this._transitionTemplate = null;

        // Opciones configurables
        this._mobileWidth = 420;    // Ancho maximo a partir del cual se ejecutaran los calculos (anchuras, alturas, animaciones) para la vista movil
        this._containerAnimationSpeed = 200;
        this._buttonsAnimationSpeed = 100;

        // Datos necesarios para la pantalla de la publicación
        this._tabs = new Tabs();
        this._editingDraft = false;
        this._editingPublishedDocument = false;
        this._mediumTitle = null;
        this._folderName = "";
        this._availableTimes = [];
        this._currentFolderId = null;
        this._changedFileOnEdit = false;
        this._titleChanged = false;
        this._articlePreviewUrl = "";
        this._showWithIframe = false;
        this._documentChanged = false;

        this._documentationPublishData = null;

        this._loadTemplates();

    }

    _loadTemplates() {
        this._template = Handlebars.compile($("#worldDocumentationPublishScreen").html());
        this._transitionTemplate = Handlebars.compile($("#documentEditorTransitionScreen").html());
    }

    _enableHandlers() {

        $("div.info-container").on("click.backStep", this._onBackStep.bind(this)); // Controlador para retroceder entre los diferentes pasos a la hora de publicar el documento
        $("div.publish-button").on("click.acceptPublication", this._onAcceptPublicacion.bind(this)); // Controlador para el boton "PUBLICAR" que dara paso al paso 2 de la publicacion (Publicar ahora o programar publicacion)
        $("div.edit-publication-button").on("click.editPublication", this._onEditPublication.bind(this)); // Controlador para modificar el fichero o llevarte al editor (ARTICULO) del documento
        $("div.close-publication-button").on("click.closePublication", this._onClosePublication.bind(this));
        $("div.publish-schedule-button").on("click.programPublication", this._onProgramPublication.bind(this)); // Controlador para desplegar el calendario para seleccionar fecha y hora de publicacion
        $("div.publish-now-button, div.publish-schedule-accept-button, p.draft-button").on("click.confirmPublication", this._onConfirmPublication.bind(this)); // Controlador para (Guardar como borrador, publicar ahora o programar publicacion)
        $("div.expandible-card-toggle-button, div.edit-data-button").on("click.toggleCardButton", this._onToggleCardButton.bind(this)); // Controlador para desplegar/ocultar la ficha con el formulario de publicacion del documento
        $("input.type-doc-input-button, input.type-image-video-input-button").on("change.changeFile", this._onFileChange.bind(this));
        $("div.form-title").on("focusout.changeTitle", this._onTitleChange.bind(this));
        $("select.form-folder").on("input.changeFolder", this._onFolderChange.bind(this));
        $("div.tag-item").on("click.changeTag", this._onTagChange.bind(this));
        $("textarea.form-description").on("focusout.changeDescription", this._onDescriptionChange.bind(this));
        $("label.edit-icon-label").on("click.openCatalogueImages", this._onOpenExternalAssets.bind(this));
        $(".publish-section div.random-cover-icon").on("click.openSuggestionsImages", this._onOpenExternalAssets.bind(this));
        $("div.cancel-button").on("click.cancelDocumentEdition", this._onCancelDocumentEdition.bind(this));
        $("div.delete-button").on("click.deleteDocument", this._onDeleteDocument.bind(this));
        $("div.confirm-edition-button").on("click.confirmEdition", this._onConfirmPublication.bind(this));

    }

    _disableHandlers() {
        $("input.type-doc-input-button, input.type-image-video-input-button").off("change.changeFile");
    }

    _setTintIcons() {

        const $toggleButtonIcon = $("#toggle-button-icon");
        const $editDataIcon = $("#edit-data-icon");
        const $rewardPointsIcon = $("canvas.reward-points-icon");

        tintImage($toggleButtonIcon.attr("id"), $toggleButtonIcon.data("icon"), "DBDBDB");
        tintImage($editDataIcon.attr("id"), $editDataIcon.data("icon"), "005F93");

        $rewardPointsIcon.each(function() {
            const $this = $(this);
            tintImage($this.attr("id"), $this.data("icon"), "FFFFFF");
        })

    }

    _setEllipsis() {

        const $contentResumeTitle = $(".content-resume p.title");
        $contentResumeTitle.dotdotdot({height: 52, watch: true});

    }

    _setExtension() {
        const documentationNew = documentationScreenController.documentationNew;

        if (this._documentationPublishData.getDocumentType() === documentationNew.ARTICLE) {
            this._documentationPublishData.setDocumentExtension("html");
        } else if (this._documentationPublishData.getDocumentType() === documentationNew.EXTERNAL) {
            this._documentationPublishData.setDocumentExtension(null);
        } else {
            const fileUrl = this._documentationPublishData.getDocumentFileUrl() || '';

            this._documentationPublishData.setDocumentExtension(fileUrl.split(".").pop());
        }

    }

    _setTitle() {

        const $formTitle = $("div.form-title");

        this._mediumTitle = new Medium({
            element: $formTitle[0],
            autofocus: false,
            autoHR: false,
            maxLength: -1,
            tags: null,
            attributes: null,
            pasteAsText: false,
            mode: Medium.inlineMode,
        });

        if (this._documentationPublishData.getDocumentTitle() === "") {

            this._documentationPublishData.setDefaultDocumentTitle();
            this._mediumTitle.value(this._documentationPublishData.getDocumentTitle());

        } else {
            this._mediumTitle.value(this._documentationPublishData.getDocumentTitle());
        }

    }

    _setFolder() {

        const $formFolder = $("select.form-folder");
        const $infoContainerFolder = $(".info-container p.folder");
        const currentFolder = documentationScreenController.getCurrentFolder();
        let currentFolderId = null;

        if (currentFolder) {
            currentFolderId = currentFolder.id;
        } else {
            currentFolderId = this._documentationPublishData.getDocumentFolderId();
        }

        // Construye el select del formulario para elegir donde guardar el documento
        DocumentationUtils.getFolderTreeDropdown(currentFolderId, this._documentationPublishData.getAvailableFolders());

        if (this._documentationPublishData.getDocumentFolderId() === null) {
            // Selecciona como carpeta donde guardar el documento la carpeta en la que nos encontramos
            DocumentationUtils.selectFirstFolder(currentFolderId);
            this._documentationPublishData.setDocumentFolderId($formFolder.val() || documentationScreenController.documentation.id);
        } else {
            $formFolder.val(this._documentationPublishData.getDocumentFolderId());
        }

        const $selectFolderForm = $("select.form-folder");
        const selectFolderOptions = $("select.form-folder > option").length;

        // No mostrar el selector de carpeta si solo existe la carpeta de root
        if (selectFolderOptions <= 1) {
            $selectFolderForm.hide();
        }

        this._folderName = $formFolder.find("option:selected").text();
        $infoContainerFolder.text(this._folderName);

    }

    _setTags() {

        // Marca las etiquetas que habiamos seleccionado (Para cuando queremos editar un borrador)
        if (this._documentationPublishData.getDocumentTags().length > 0) {
            _.each(this._documentationPublishData.getDocumentTags(), function(tag) {
                const $tagItem = $(".form-tags > .tag-item[data-value='" + tag + "']");
                $tagItem.addClass("selected world_color_1_bg");
            });
        }

    }

    _setDateTime() {

        // Establece en el calendario las fechas y tiempos actuales como primera opcion
        // Si existen (Se esta editando el borrador) se marcaran las existentes
        if (!this._documentationPublishData.getDocumentDate() && !this._documentationPublishData.getDocumentTime()) {

            const date = new Date();
            const currentDay = date.getDate();
            const currentMonth = date.getMonth() + 1;
            const currentYear = date.getFullYear();
            let currentHour = date.getHours();
            let currentMinute = date.getMinutes();

            if (currentMinute >= 0 && currentMinute < 30) {
                currentMinute = "30";
            } else {
                currentHour += 1;
                currentMinute = "00";
            }

            this._documentationPublishData.setDocumentTime(currentHour + ":" + currentMinute);
            this._documentationPublishData.setDocumentDate(currentDay + "/" + currentMonth + "/" + currentYear);

        }

    }

    _setDraftData(draft) {

        const documentationNew = documentationScreenController.documentationNew;
        const folder = draft.folder;
        const tags = draft.tags && draft.tags.length > 0 ? draft.tags.split(",") : [];

        this._documentationPublishData.setDocumentIconUrl(draft.icon);
        this._folderName = folder.name;

        this._documentationPublishData.setDocumentId(draft.id);
        this._documentationPublishData.setDocumentTitle(draft.name);
        this._documentationPublishData.setDocumentFolderId(folder.id);
        this._documentationPublishData.setDocumentTags(tags);
        this._documentationPublishData.setDocumentDescription(draft.html_description);

        if (this._documentationPublishData.getDocumentType() === documentationNew.ARTICLE) {
            this._documentationPublishData.setArticleDocumentData(draft.article_html, draft.article_cover, draft.article_title);
        }

        if (this._documentationPublishData.getDocumentType() === documentationNew.EXTERNAL) {
            this._documentationPublishData.setExternalContentData(
                draft.content_external.url,
                draft.content_external.site,
                draft.content_external.duration,
                draft.content_external.media,
                draft.content_external.html,
                draft.content_external.html_card,
                draft.content_external.rel,
                draft.content_external.thumbnail
            );
        }

    }

    _onOpenExternalAssets(event) {

        const $this = $(event.currentTarget);
        const $body = $("body");
        const isCatalogue = $this.data("catalogue");
        const suggestionsTerm = this._titleChanged ? this._documentationPublishData.getDocumentTitle() : "";

        $body.removeClass("no-scroll");
        externalAssetsController.initialize(!isCatalogue, suggestionsTerm, this._documentationPublishData.getDocumentType(), this._onIconChange.bind(this));

    }

    _onFileChange(event) {

        function _onUploadSuccess(response) {

            if (api.checkisValidResult(response)) {

                that._documentationPublishData.setDocumentFileUrl(response.result.url);
                that._changedFileOnEdit = true;

                switch(type) {

                    case "application":
                        const $document = $("iframe.document");
                        DocumentationUtils.insertDocIframe($document, that._documentationPublishData.getDocumentFileUrl(), true);
                        break;

                    case "image":
                        const $image = $("div.image");
                        $image.css("background-image", "url(" + that._documentationPublishData.getDocumentFileUrl() + ")");
                        break;

                    case "video":
                        const $video = $("video.video");
                        const $videoSource = $("video.video > source");
                        $videoSource.attr("src", that._documentationPublishData.getDocumentFileUrl());
                        $video[0].load();
                        break;

                }

            }

        }

        const $this = $(event.currentTarget);
        const that = this;
        const file = $this[0].files[0];
        const type = file.type.split("/")[0];
        const $publishChangesButton = $("div.confirm-edition-button");

        this._documentChanged = true;

        if (this._editingPublishedDocument) {
            $publishChangesButton.removeClass("disabled");
        }

        api.uploadDocumentPreview(file, _onUploadSuccess, true);

        $this.prop("value", "");

    }

    _onIconChange(response) {

        const base64 = response.base64;
        const url = response.url;

        const $infoContainerIcon = $(".info-container > div.icon");
        const $formIcon = $(".form-icon > div.icon");
        const $publishChangesButton = $("div.confirm-edition-button");

        $infoContainerIcon.removeClass("default-image-background");
        $infoContainerIcon.css("background-image", "url(" + url + ")");
        $formIcon.removeClass("default-image-background");
        $formIcon.css("background-image", "url(" + url + ")");

        if (base64) {

            this._documentationPublishData.setDocumentIconUrl(url);
            this._documentationPublishData.setDocumentIcon(url.match(/,(.*)$/)[1]);

        } else {

            this._documentationPublishData.setDocumentIcon(null);
            this._documentationPublishData.setDocumentIconUrl(url);

        }

        this._documentChanged = true;

        if (this._editingPublishedDocument) {
            $publishChangesButton.removeClass("disabled");
        }

    }

    _onTitleChange(event, newTitle) {

        let $this = null;
        let title = "";

        if (event) {
            $this = $(event.currentTarget);
            title = $this.text().trim();
        } else if (newTitle) {
            title = newTitle;
        }

        const $infoContainerTitle = $(".info-container p.title");
        const $publishChangesButton = $("div.confirm-edition-button");
        const documentationNew = documentationScreenController.documentationNew;

        if (title.length > 0) {

            this._documentationPublishData.setDocumentTitle(title);
            this._mediumTitle.value(this._documentationPublishData.getDocumentTitle());
            this._titleChanged = true;

        } else {

            this._titleChanged = false;
            this._documentationPublishData.setDefaultDocumentTitle();
            this._mediumTitle.value(this._documentationPublishData.getDocumentTitle());

        }

        this._documentChanged = true;

        if (this._editingPublishedDocument) {
            $publishChangesButton.removeClass("disabled");
        }

        $infoContainerTitle.text(this._documentationPublishData.getDocumentTitle());

    }

    _onFolderChange(event) {

        const $this = $(event.currentTarget);
        const $infoContainerFolder = $(".info-container p.folder");
        const $publishChangesButton = $("div.confirm-edition-button");

        this._documentationPublishData.setDocumentFolderId($this.val());
        this._folderName = $this.find("option:selected").text();

        this._documentChanged = true;

        if (this._editingPublishedDocument) {
            $publishChangesButton.removeClass("disabled");
        }

        $infoContainerFolder.text(this._folderName);

    }

    _onTagChange(event) {

        const $this = $(event.currentTarget);
        const $publishChangesButton = $("div.confirm-edition-button");

        $this.toggleClass("world_color_1_bg selected");

        if ($this.hasClass("selected")) {
            this._documentationPublishData.addDocumentTag($this.text());
        } else {
            this._documentationPublishData.removeDocumentTag($this.text());
        }

        this._documentChanged = true;

        if (this._editingPublishedDocument) {
            $publishChangesButton.removeClass("disabled");
        }

    }

    _onDescriptionChange(event, newDescription) {

        let $this = null;
        let description = "";

        if (event) {
            $this = $(event.currentTarget);
            description = $this.val().trim();
        } else if (newDescription) {
            description = newDescription;
        }

        const $descriptionForm = $("textarea.form-description");
        const $publishChangesButton = $("div.confirm-edition-button");

        if (description.length > 0) {
            this._documentationPublishData.setDocumentDescription(description);
        } else {
            this._documentationPublishData.setDocumentDescription("");
        }

        this._documentChanged = true;

        if (this._editingPublishedDocument) {
            $publishChangesButton.removeClass("disabled");
        }

        $descriptionForm.val(description);

    }

    _onBackStep(event) {

        function _onCollapseAnimationComplete() {
            const $this = $(this);
            $this.removeClass("expanded");
        }

        function _onContainerAnimationComplete() {
            const $this = $(this);
            const $cardToggleButton = $("div.expandible-card-toggle-button");
            $this.removeClass("overlapped");
            $cardToggleButton.show();
        }

        function _onButtonsAnimationComplete() {

            const $this = $(this);

            $this.hide();

            if ($this.hasClass("publish-time-options")) {
                $publishOptions.show();
                $publishOptions.animate({ bottom: 0 + "px"}, that._buttonsAnimationSpeed);
            } else if ($this.hasClass("publish-accept-time-options")) {
                $publishTimeOptions.show();
                $publishTimeOptions.animate({ bottom: 0 + "px"}, that._buttonsAnimationSpeed);
            }

        }

        const $this = $(event.currentTarget);
        const $window = $(window);
        const $publishOptions = $(".bottom-card > div.publish-options");
        const $publishTimeOptions = $("div.publish-time-options");
        const $publishAcceptTimeOptions = $("div.publish-accept-time-options");
        const that = this;

        // Condiciones para saber en que paso de la publicacion estaremos (se basa en saber que bloque de botones estaba en pantalla para saber a que paso retroceder)
        if ($this.hasClass("overlapped")) {

            if ($publishTimeOptions.css("display") === "block") {

                const $editDataButton = $("div.edit-data-button");
                const $infoContainer = $("div.info-container");
                const $infoContainerIcon = $("div.info-container > .icon");
                const expandContainerToWidth = _.min([500, $window.width()]) + "px";
                const expandIconToWidth = $window.width() > this._mobileWidth ? 99 : 89;
                const expandIconToHeight = expandIconToWidth;

                $editDataButton.show();
                $infoContainer.animate({top: 0 + "px", width: expandContainerToWidth}, this._containerAnimationSpeed, _onContainerAnimationComplete);
                $infoContainerIcon.animate({width: expandIconToWidth + "px", height: expandIconToHeight + "px"}, this._containerAnimationSpeed);
                $publishTimeOptions.animate({bottom: -200 + "px"}, this._buttonsAnimationSpeed, _onButtonsAnimationComplete);

            } else if ($publishAcceptTimeOptions.css("display") === "block") {

                const $bottomCard = $("div.bottom-card");
                const $contentSchedule = $("div.content-schedule");
                const collapseToHeight = $window.width() > this._mobileWidth ? 275 + "px" : 255 + "px";

                $bottomCard.animate({height: collapseToHeight}, _onCollapseAnimationComplete);
                $contentSchedule.animate({opacity: 0, zIndex: 0});
                $publishAcceptTimeOptions.animate({bottom: -200 + "px"}, this._buttonsAnimationSpeed, _onButtonsAnimationComplete);

            }

        }

    }

    _onAcceptPublicacion(event) {

        function _onContainerAnimationComplete() {
            const $this = $(this);
            $this.addClass("overlapped");
        }

        function _onButtonsAnimationComplete() {

            const $this = $(this);
            const $publishTimeOptions = $("div.publish-time-options");

            $this.hide();
            $publishTimeOptions.show();
            $publishTimeOptions.animate({ bottom: 0 + "px"}, that._buttonsAnimationSpeed);

        }

        const $window = $(window);
        const $bottomCard = $("div.bottom-card");
        const $editDataButton = $("div.edit-data-button");
        const $infoContainer = $("div.info-container");
        const $infoContainerIcon = $("div.info-container > .icon");
        const $publishOptions = $(".bottom-card > div.publish-options");
        const $cardToggleButton = $("div.expandible-card-toggle-button");
        const that = this;
        const reduceContainerToWidth = $window.width() > this._mobileWidth ? 400 + "px" : 310 + "px";

        if ($bottomCard.hasClass("expanded")) {
            this._onToggleCardButton();
        }

        $editDataButton.hide();
        $cardToggleButton.hide();
        $infoContainer.animate({top: -80 + "px", width: reduceContainerToWidth}, this._containerAnimationSpeed, _onContainerAnimationComplete);
        $infoContainerIcon.animate({width: 80 + "px", height: 80 + "px"}, this._containerAnimationSpeed);
        $publishOptions.animate({bottom: -200 + "px"}, this._buttonsAnimationSpeed, _onButtonsAnimationComplete);

    }

    _onEditPublication(event) {

        function _onCreatedArticlePreview(previewUrl) {

            const $article = $("iframe.article");

            that._articlePreviewUrl = previewUrl;

            // Eliminar la seccion con el editor del articulo una vez nos ha llegado la url de previsualizacion
            baseController.closeStack();

            $article.attr("src", that._articlePreviewUrl);

        }

        function _onSuccessArticleEdition (newArticleContent) {

            that._documentationPublishData.setArticleDocumentData(newArticleContent.html, newArticleContent.cover, newArticleContent.title);

            const articleHtml = that._documentationPublishData.getArticleDocumentHtml();
            const articleCover = that._documentationPublishData.getArticleDocumentCover();
            const articleTitle = that._documentationPublishData.getArticleDocumentTitle();

            documentationNew.articleDocument.clearData();
            documentationNew.articleDocument.createArticlePreview(articleHtml, articleCover, articleTitle, _onCreatedArticlePreview);

            that._onTitleChange(null, articleTitle);
            that._onIconChange({url: articleCover});

        }

        function _onSuccessExternalContentEdition(newExternalContent) {

            that._documentationPublishData.setExternalContentData(
                newExternalContent.url,
                newExternalContent.site,
                newExternalContent.duration,
                newExternalContent.media,
                newExternalContent.html,
                newExternalContent.card,
                newExternalContent.rel,
                newExternalContent.thumbnail
            );

            that._onTitleChange(null, newExternalContent.title);
            that._onDescriptionChange(null, newExternalContent.description);

            api.checkDocumentationLink(newExternalContent.url, _onCheckedExternalUrl);

        }

        function _onCheckedExternalUrl(response) {

            if (api.checkisValidResult(response)) {

                if (response.result) {
                    that._showWithIframe = true;
                } else {
                    that._showWithIframe = false;
                }

                if (that._documentationPublishData.getExternalContentThumbnail()) {
                    that._onIconChange({url: that._documentationPublishData.getExternalContentThumbnail()});
                } else {
                    api.getRandomPhotos(that._documentationPublishData.getDocumentTitle(), 1, that._documentationPublishData.getDocumentType(), function(response) {

                        if (api.checkisValidResult(response)) {
                            that._onIconChange({url: response.result});
                        }

                    }, true, false);
                }

                // Eliminar la seccion con el editor del contenido externo una vez nos ha llegado el nuevo html
                baseController.closeStack();

                const $external = $("div.external");
                const isWebsite = that._documentationPublishData.getExternalContentRel().indexOf("summary") >= 0 || !that._documentationPublishData.getExternalContentHtml();

                if (isWebsite && that._showWithIframe) {
                    $external.html("<iframe class='doc-details-URL' src='" + that._documentationPublishData.getExternalContentUrl() + "' frameborder='0'></iframe>");
                    $external.removeClass("overflow-auto");
                } else if (isWebsite) {
                    $external.html(that._documentationPublishData.getExternalContentHtml());
                    $external.addClass("overflow-auto");
                } else {
                    $external.html("<div>" + that._documentationPublishData.getExternalContentHtml() + "</div>");
                    $external.addClass("overflow-auto");
                }

                documentationNew.externalDocument.clearData();

                const $externalContainer = $("div.external > div");

                if (!$external.hasScrollBar()) {
                    $externalContainer.addClass("vcenter-relative");
                } else {
                    $externalContainer.removeClass("vcenter-relative");
                }

            }

        }

        const documentationNew = documentationScreenController.documentationNew;
        const that = this;

        switch(this._documentationPublishData.getDocumentType()) {

            case documentationNew.ARTICLE:
                const articleHtml = that._documentationPublishData.getArticleDocumentHtml();
                const articleCover = that._documentationPublishData.getArticleDocumentCover();
                const articleTitle = that._documentationPublishData.getArticleDocumentTitle();
                documentationNew.articleDocument.editArticle(articleHtml, articleCover, articleTitle, _onSuccessArticleEdition);
                break;

            case documentationNew.DOCUMENT:
                const $typeDocInputButton = $("input.type-doc-input-button:last");
                $typeDocInputButton.trigger("click.openFileChooser");
                break;

            case documentationNew.IMAGE:
            case documentationNew.VIDEO:
                const $typeImageVideoInputButton = $("input.type-image-video-input-button:last");
                $typeImageVideoInputButton.trigger("click.openFileChooser");
                break;

            case documentationNew.EXTERNAL:
                documentationNew.externalDocument.initialize(false, _onSuccessExternalContentEdition);
                break;

        }

    }

    _onClosePublication(event, showModal = this._documentChanged, closeMyContents = false, afterClosePublicationFunction) {

        function _exit() {

            const documentationNew = documentationScreenController.documentationNew;

            switch(that._documentationPublishData.getDocumentType()) {

                case documentationNew.ARTICLE:
                    baseController.closeStack();
                    documentationNew.articleDocument.clearData();
                    break;

                case documentationNew.DOCUMENT:
                    baseController.closeStack();
                    documentationNew.docDocument.clearData();
                    break;

                case documentationNew.IMAGE:
                case documentationNew.VIDEO:
                    baseController.closeStack();
                    documentationNew.imageVideoDocument.clearData();
                    break;

                case documentationNew.EXTERNAL:
                    baseController.closeStack();
                    documentationNew.externalDocument.clearData();
                    break;

            }

            window.scrollTo(0, documentationNew.lastYScrollPosition);

            if (!that._editingDraft) {
                documentationNew.onToggleNewButton();
            } else if (closeMyContents) {
                const $myContentsCloseButton = $("div.my-contents-close-button");
                $myContentsCloseButton.trigger("click.closeMyContents");
            }

            if (!afterClosePublicationFunction) {
                that.clearData();
            }

        }

        function _saveChanges() {

            const $draftButton = $(".bottom-card > .publish-options > p.draft-button");
            const $confirmEditionButton = $("div.confirm-edition-button");

            if ($draftButton.length > 0) {
                $draftButton.trigger("click.confirmPublication");
            } else if ($confirmEditionButton.length > 0) {
                $confirmEditionButton.trigger("click.confirmEdition");
            }

        }

        const that = this;

        if (showModal) {

            const swalOptions = {
                title: "",
                text: sprintf(Translator.trans("TR_DESEAS_GUARDAR_LOS_CAMBIOS_DE"), this._documentationPublishData.getDocumentTitle()),
                type: "warning",
                showConfirmButton: true,
                showCancelButton: true,
                closeOnConfirm: false,
                closeOnCancel: false,
                confirmButtonText: Translator.trans("TR_GUARDAR").toUpperCase(),
                confirmButtonColor: "#85DD01",
                cancelButtonText: this._editingPublishedDocument ? Translator.trans("TR_DESCARTAR_CAMBIOS").toUpperCase() : Translator.trans("TR_DESCARTAR").toUpperCase(),
                allowEscapeKey: false
            }

            swal(swalOptions, function(saveChanges) {

                if (saveChanges) {
                    _saveChanges();
                } else {

                    that.drawExitTransitionScreen();

                    setTimeout(function() {
                        that.closeTransitionScreen();
                        _exit();
                        afterClosePublicationFunction ? afterClosePublicationFunction() : null;
                    }, 2000);
                }

                swal.close();

            });

        } else {

            that.drawExitTransitionScreen();

            setTimeout(function() {
                that.closeTransitionScreen();
                _exit();
                afterClosePublicationFunction ? afterClosePublicationFunction() : null;
            }, 2000);

        }

    }

    _onProgramPublication(event) {

        function _onExpandAnimationComplete() {

            const $this = $(this);
            const $timepicker = $("#timepicker");

            $this.addClass("expanded");
            $timepicker.trigger("refresh.owl.carousel");

        }

        function _onButtonsAnimationComplete() {

            const $this = $(this);
            const $publishAcceptTimeOptions = $("div.publish-accept-time-options");

            $this.hide();
            $publishAcceptTimeOptions.show();
            $publishAcceptTimeOptions.animate({ bottom: 0 + "px"}, that._buttonsAnimationSpeed);

        }

        const $window = $(window);
        const $bottomCard = $("div.bottom-card");
        const $publishTimeOptions = $("div.publish-time-options");
        const $contentSchedule = $("div.content-schedule");
        const that = this;
        const topSeparation = 125;
        const expandToHeight = $window.height() - topSeparation + "px";

        $bottomCard.animate({height: expandToHeight}, _onExpandAnimationComplete);
        $publishTimeOptions.animate({bottom: -200 + "px"}, this._buttonsAnimationSpeed, _onButtonsAnimationComplete);
        $contentSchedule.animate({opacity: 1, zIndex: 1});

    }

    _onConfirmPublication(event) {

        function _afterClosePublication(response) {

            const alertOptions = {
                icon: "/images/icons/app-icons/ico-content-completed.svg",
                animationDuration: 4000
            }
            const documentationNew = documentationScreenController.documentationNew;
            const document = documentationScreenController.getDocument(that._documentationPublishData.getDocumentId());
            const documentTitle = that._documentationPublishData.getDocumentTitle();
            const documentProgrammedDate = that._documentationPublishData.getDocumentDate() + " " + that._documentationPublishData.getDocumentTime();
            const currentFolderId = that._currentFolderId;
            const currentFolder = documentationScreenController.getCurrentFolder();
            const openDocumentation = baseController.selectedTabId === that._tabs.LINKS_TAB;
            const editingPublishedDocument = that._editingPublishedDocument;
            const $closeDetailsButton = $("#documentation-header-close-btn");

            if ($closeDetailsButton.length > 0) {
                $closeDetailsButton.trigger("click");
            }

            // Solo se debera llevar al usuario de nuevo a la carpeta donde estaba si cuando creo el documento se encontraba en la documentacion y no era un borrador editado (si es borrador editado estaba en mis contenidos)
            if (openDocumentation) {
                // Se utiliza documentObj sin datos del documento y con el foldersStack para poder devolver al usuario a la carpeta en la que se encontraba
                documentObj = new DocumentObj({}, documentationScreenController.foldersStack);
                documentationScreenController.documentation = response.result;
                documentationScreenController.openDocumentation(response.result, currentFolderId, null, false);

                if (editingPublishedDocument) {
                    documentationScreenController.drawDocumentDetails(null, document, null, currentFolder);
                }

            } else {
                documentationScreenController.documentation = response.result;
            }

            if (isDraft) {
                alertOptions.title = Translator.trans("TR_GUARDADO");
                alertOptions.content = "<p class=text>" + sprintf(Translator.trans("TR_SE_HA_GUARDADO_EN_BORRADORES"), "<b>" + documentTitle + "</b>") + "</p>";
            } else if (programPublication) {
                alertOptions.title = Translator.trans("TR_PERFECTO");
                alertOptions.content = "<p class=text>" + sprintf(Translator.trans("TR_SE_PUBLICARA_EL"), "<b>" + documentTitle + "</b>", "<b>" + documentProgrammedDate + "</b>") + "</p>";
            } else if (editingPublishedDocument) {
                alertOptions.title = Translator.trans("TR_PUBLICADO");
                alertOptions.content = "<p class=text>" + sprintf(Translator.trans("TR_SE_HAN_PUBLICADO_LOS_CAMBIOS_EN"), "<b>" + documentTitle + "</b>") + "</p>";
            } else {
                alertOptions.title = Translator.trans("TR_PERFECTO");
                alertOptions.content = "<p class=text>" + sprintf(Translator.trans("TR_SE_HA_PUBLICADO"), "<b>" + documentTitle + "</b>") + "</p>";
            }

            if (!$this.data("draft") && !$this.data("programmed")) {
                DocumentationUtils.showPointsModal(formatValueByLocale(world.documentation_upload_points));
            }

            alertController.setOptions(alertOptions);
            alertController.show();

        }

        function _onUploadSuccess(response) {

            if (api.checkisValidResult(response)) {
                const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

                if(isModuleApp) {
                    window.reactZustandBridge.invalidateQuery('section');

                    const folderId = buildedDocumentData.folder_id;

                    api.getFolderDocuments(
                        folderId,
                        0,
                        documentationScreenController.documentationPageSize,
                        (e) => {
                            if(e.result) {
                                window.reactZustandBridge.setSection(e.result);
                            }

                            history.back();

                            // We need to close this once the upload has finished
                            that._onClosePublication(null, false, false, function() {
                                _afterClosePublication(response);
                                that.clearData();
                            });

                        }
                    );
                } else {
                    const folderId = baseController.currentActiveTab?.folder_tab_id;

                    if (folderId) {
                        api.getFolderDocuments(
                            folderId,
                            0,
                            documentationScreenController.documentationPageSize,
                            _onGetDocumentationSuccess
                        );
                    }
                }
            }

        }

        function _onGetDocumentationSuccess(response) {

            if (api.checkisValidResult(response)) {
                that._onClosePublication(null, false, true, function() {
                    _afterClosePublication(response);
                    that.clearData();
                });
            }

        }

        const $this = $(event.currentTarget);
        const that = this;
        const documentationNew = documentationScreenController.documentationNew;
        const isDraft = $this.data("draft");
        const publishNow = $this.data("now");
        const programPublication = $this.data("programmed");
        let buildedDocumentData = {};

        // show loading that will hide when apiCall finish (upload)
        const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';
        if (isModuleApp) {
            $('#modalLoading').modal('show');
        }

        if (this._documentationPublishData.getDocumentType() === documentationNew.EXTERNAL) {

            buildedDocumentData = this._documentationPublishData.getExternalDocumentData(publishNow, programPublication, this._editingDraft, this._editingPublishedDocument);
            this._editingDraft ? api.editExternalContent(buildedDocumentData, _onUploadSuccess) : api.uploadExternalContent(buildedDocumentData, _onUploadSuccess);

        } else if (this._documentationPublishData.getDocumentType() === documentationNew.ARTICLE) {

            buildedDocumentData = this._documentationPublishData.getArticleDocumentData(publishNow, programPublication, this._editingDraft, this._editingPublishedDocument);
            this._editingDraft ? api.editDocument(buildedDocumentData, _onUploadSuccess) : api.uploadDocument(buildedDocumentData, _onUploadSuccess);

        } else {

            buildedDocumentData = this._documentationPublishData.getDocumentData(publishNow, programPublication, this._editingDraft, this._editingPublishedDocument, this._changedFileOnEdit);
            this._editingDraft ? api.editDocument(buildedDocumentData, _onUploadSuccess) : api.uploadDocument(buildedDocumentData, _onUploadSuccess);

        }

    }

    _onCancelDocumentEdition(event) {
        this._onClosePublication(null, this._documentChanged, false);
    }

    _onDeleteDocument(event) {

        function _afterClosePublication(response) {

            const alertOptions = {
                icon: "/images/icons/app-icons/ico-ux-delete.svg",
                animationDuration: 4000,
                title: Translator.trans("TR_ELIMINADO"),
                content: "<p class=text>" + sprintf(Translator.trans("TR_X_SE_HA_ELIMINADO"), "<b>" + that._documentationPublishData.getDocumentTitle() + "</b>") + "</p>"
            }
            const $closeDetailsButton = $("#documentation-header-close-btn");
            const folderId = baseController.currentActiveTab.folder_tab_id;

            $closeDetailsButton.trigger("click");

            documentationScreenController.setDocumentation(response.result);
            baseController.selectedTabAction(baseController.currentActiveTab.world_tab_id, folderId);

            alertController.setOptions(alertOptions);
            alertController.show();

        }

        function _onGetDocumentationSuccess(response) {

            if (api.checkisValidResult(response)) {

                // Cerrar el editor de publicaciones y la vista detalles del documento
                that._onClosePublication(null, false, false, function() {
                    _afterClosePublication(response);
                    that.clearData();
                });


            }

        }

        function onSuccessDelete(response) {
            // Invalidar la query de sections para pedir de nuevo los datos
            window.reactZustandBridge.invalidateQuery('section');

            if (api.checkisValidResult(response)) {
                _onGetDocumentationSuccess(response);
            }

        }

        const that = this;
        const swalOptions = {
            title: "",
            text: Translator.trans("TR_SEGURO_QUE_QUIERES_ELIMINAR_CONTENIDO"),
            type: "warning",
            showConfirmButton: true,
            showCancelButton: true,
            closeOnConfirm: false,
            closeOnCancel: false,
            confirmButtonText: Translator.trans("TR_ELIMINAR").toUpperCase(),
            confirmButtonColor: "#F5222D",
            cancelButtonText: Translator.trans("TR_CANCELAR").toUpperCase(),
            allowEscapeKey: false
        }

        swal(swalOptions, function(confirmDelete) {

            if (confirmDelete) {
                api.deleteDocument(that._documentationPublishData.getDocumentId(), onSuccessDelete);
            }

            swal.close();

        });

    }

    _onToggleCardButton(event) {

        function _onExpandAnimationComplete() {
            const $this = $(this);
            $this.addClass("expanded");
        }

        function _onCollapseAnimationComplete() {
            const $this = $(this);
            $this.removeClass("expanded");
        }

        const $window = $(window);
        const $bottomCard = $("div.bottom-card");
        const $infoContainer = $("div.info-container");
        const $contentForm = $("div.content-form");
        const $publishOptions = $(".bottom-card > div.publish-options");
        const $editionOptions = $(".bottom-card > div.edit-publication-options");

        if (!$bottomCard.hasClass("expanded")) {

            const topSeparation = 22;
            const expandToHeight = $window.height() - topSeparation + "px";

            $bottomCard.animate({height: expandToHeight}, _onExpandAnimationComplete);
            $infoContainer.animate({opacity: 0, zIndex: 0});
            $contentForm.animate({opacity: 1, zIndex: 1});

            if (this._editingPublishedDocument) {
                $editionOptions.animate({opacity: 0, zIndex: 0});
            } else {
                $publishOptions.animate({opacity: 0, zIndex: 0});
            }

        } else {

            let collapseToHeight = null;

            if (this._editingPublishedDocument) {
                collapseToHeight = $window.width() > this._mobileWidth ? 375 + "px" : 320 + "px";
            } else {
                collapseToHeight = $window.width() > this._mobileWidth ? 275 + "px" : 255 + "px";
            }


            $bottomCard.animate({height: collapseToHeight}, _onCollapseAnimationComplete);
            $infoContainer.animate({opacity: 1, zIndex: 1});
            $contentForm.animate({opacity: 0, zIndex: 0});

            if (this._editingPublishedDocument) {
                $editionOptions.animate({opacity: 1, zIndex: 1});
            } else {
                $publishOptions.animate({opacity: 1, zIndex: 1});
            }

        }

    }

    _initializeDateTimePicker() {

        function _onSelectDate(dateText, inst) {

            const availableTimesDay = parseInt(inst.selectedDay);
            const availableTimes = DocumentationUtils.getAvailableTimes(availableTimesDay);
            const index = availableTimes.indexOf(that._documentationPublishData.getDocumentTime());
            let timePickerTimesHtml = "";

            _.forEach(availableTimes, function(time) {
                timePickerTimesHtml += "<p class=text>" + time + "</p>";
            });

            that._documentationPublishData.setDocumentDate(dateText);
            that._availableTimes = availableTimes;

            $timePicker.trigger("replace.owl.carousel", timePickerTimesHtml);
            $timePicker.trigger("refresh.owl.carousel");
            $timePicker.trigger("to.owl.carousel", [index, 0]);

        }

        function _onSelectTime(event) {

            that._documentationPublishData.setDocumentTime(that._availableTimes[event.item.index]);
            $publishScheduleAcceptButton.text(sprintf(Translator.trans("TR_PUBLICAR_EL"), that._documentationPublishData.getDocumentDate() + " " + that._documentationPublishData.getDocumentTime()));

        }

        const $datePicker = $("#datepicker");
        const $timePicker = $("#timepicker");
        const $publishScheduleAcceptButton = $(".publish-schedule-accept-button > span.button-text");
        const that = this;

        $datePicker.datepicker(DatePicker.defaultDatePickerOptions(_onSelectDate));

        $timePicker.owlCarousel({
            items: 5,
            center: true,
            dots: false,
            nav: true,
            navText: [
                "<svg class='icon' width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M10 19L3 12M3 12L10 5M3 12L21 12' stroke='#4A5568' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>",
                "<svg class='icon' width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M14 5L21 12M21 12L14 19M21 12L3 12' stroke='#4A5568' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>"
            ],
            startPosition: that._availableTimes.indexOf(that._documentationPublishData.getDocumentTime())
        });

        $datePicker.datepicker("setDate", that._documentationPublishData.getDocumentDate());
        $timePicker.on("changed.owl.carousel", _onSelectTime);
        $publishScheduleAcceptButton.text(sprintf(Translator.trans("TR_PUBLICAR_EL"), that._documentationPublishData.getDocumentDate() + " " + that._documentationPublishData.getDocumentTime()));

    }

    _drawScreen() {

        const documentationNew = documentationScreenController.documentationNew;
        const availableTimesDay = parseInt(this._documentationPublishData.getDocumentDate().split("/")[0]) || new Date().getDate();
        const availableTimes = DocumentationUtils.getAvailableTimes(availableTimesDay);
        const isWebsite = this._documentationPublishData.getExternalContentRel().indexOf("summary") >= 0 || !this._documentationPublishData.getExternalContentHtml();
        const context = {
            ARTICLE: documentationNew.ARTICLE,
            IMAGE: documentationNew.IMAGE,
            VIDEO: documentationNew.VIDEO,
            DOCUMENT: documentationNew.DOCUMENT,
            EXTERNAL: documentationNew.EXTERNAL,
            world: world,
            articlePreviewUrl: this._articlePreviewUrl,
            showWithIframe: this._showWithIframe,
            externalContentHtml: this._documentationPublishData.getExternalContentHtml(),
            externalContentUrl: this._documentationPublishData.getExternalContentUrl(),
            isWebsite: isWebsite,
            document: {
                type: this._documentationPublishData.getDocumentType(),
                fileUrl: this._documentationPublishData.getDocumentFileUrl(),
                iconUrl: this._documentationPublishData.getDocumentIconUrl(),
                title: this._documentationPublishData.getDocumentTitle(),
                description: this._documentationPublishData.getDocumentDescription(),
                date: this._documentationPublishData.getDocumentDate(),
                time: this._documentationPublishData.getDocumentTime()
            },
            availableTimes: availableTimes,
            documentationTags: documentationScreenController.documentationTags,
            editingPublishedDocument: this._editingPublishedDocument
        }

        this._availableTimes = availableTimes;
        baseController.stackSimpleContent(this._template, context, 'CONTENT');

        if (this._documentationPublishData.getDocumentType() === documentationNew.DOCUMENT) {
            const $document = $("iframe.document");
            DocumentationUtils.insertDocIframe($document, this._documentationPublishData.getDocumentFileUrl(), true);
        }

        if (this._documentationPublishData.getDocumentType() === documentationNew.EXTERNAL) {

            const $external = $("div.external");
            const $externalContainer = $("div.external > div");

            if (!$external.hasScrollBar()) {
                $externalContainer.addClass("vcenter-relative");
            } else {
                $externalContainer.removeClass("vcenter-relative");
            }

        }

    }

    drawEnterTransitionScreen() {

        const $detailsHeaderCloseButton = $("#documentation-header-close-btn");

        if ($detailsHeaderCloseButton.length > 0) {
            $detailsHeaderCloseButton.hide();
        }

        baseController.stackSimpleContent(this._transitionTemplate , {
            world: world,
            title: Translator.trans("TR_ENTRANDO_AL_EDITOR")
        }, 'CONTENT');
    }

    drawExitTransitionScreen() {
        const $detailsHeaderCloseButton = $("#documentation-header-close-btn");

        if ($detailsHeaderCloseButton.length > 0) {
            $detailsHeaderCloseButton.show();
        }

        baseController.stackSimpleContent(this._transitionTemplate , {
            world: world,
            title: Translator.trans("TR_SALIENDO_DEL_EDITOR")
        }, 'CONTENT');

        // If module app and editing post out, redirect to home
        const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

        if(isModuleApp && (location.href.includes('external-link') || location.href.includes('edit-post'))) {
            setTimeout(() => {
                // window.location.href = '/#/';
                history.back();
            }, 2100);
        }
    }

    closeTransitionScreen() {
        baseController.closeStack();
    }

    goToEdition(event) {

        const that = this;
        const $this = $(event.currentTarget);
        const documentId = $this.data("id");
        const document = documentationScreenController.getDocument(documentId);
        const documentationNew = documentationScreenController.documentationNew;
        let documentType = "";

        // Asegurar que el tipo del documento que se le envia a la pantalla de publicacion para editar el documento coincide con la lista del documentationNew
        switch (document.type) {

            case "ARTICLE":
                documentType = documentationNew.ARTICLE;
                break;

            case "IMAGE":
                documentType = documentationNew.IMAGE;
                break;

            case "VIDEO":
                documentType = documentationNew.VIDEO;
                break;

            case "DOC":
            case "PDF":
                documentType = documentationNew.DOCUMENT;
                break;

            case "URL":
                documentType = documentationNew.EXTERNAL;
                break;

        }

        if (!documentationScreenController.documentationTags) {
            api.getDocumentTags(function (response) {
                documentationScreenController.documentationTags = response.result.tags;
            }, false);
        }

        // FYI: This is a shit code, but it doesn't deserve anything else... the whole project is a mess
        const isModuleApp = window.reactZustandBridge && world?.mode === 'newLayout';
        if (isModuleApp) {
            window.location.href = '/#/edit-post';
            const $closeDetailsButton = $("#documentation-header-close-btn");
            $closeDetailsButton.trigger("click");

            setTimeout(function() {
                that.drawEnterTransitionScreen();
            }, 100);
        }

        this.drawEnterTransitionScreen();

        setTimeout(function() {
            that.initialize(documentType, document.url, document, null, null, true);
        }, 2000);

    }

    initialize(documentType, fileUrl, draft, editorData, externalContentData, editPublishedDocument = false) {

        // Helper del bloque de funciones a ejecutar al inicializar la publicación de un contenido
        function _callInitFunctions() {

            api.getAvailableUploadFolders(function(response) {

                that._documentationPublishData.setAvailableFolders(response.result);

                const $publishTransitionSection = $("section.publish-transition-section");

                if ($publishTransitionSection.length > 0) {
                    that.closeTransitionScreen();
                }

                that._drawScreen();
                that._setTintIcons();
                that._setEllipsis();
                that._setExtension();
                that._setTitle();
                that._setFolder();
                that._setTags();
                that._setDateTime();
                that._enableHandlers();
                that._initializeDateTimePicker();

            }, false);

        }

        function _onCreatedArticlePreview(previewUrl) {

            const $editorSection = $("section.new-document-section");

            // Eliminar la seccion con el editor del articulo una vez nos ha llegado la url de previsualizacion
            $editorSection.remove();

            that._articlePreviewUrl = previewUrl;
            _callInitFunctions();

        }

        function _onCheckedExternalUrl(response) {

            if (api.checkisValidResult(response)) {

                if (response.result) {
                    that._showWithIframe = true;
                } else {
                    that._showWithIframe = false;
                }

                if (!draft) {
                    if (that._documentationPublishData.getExternalContentThumbnail()) {

                        that._documentationPublishData.setDocumentIconUrl(that._documentationPublishData.getExternalContentThumbnail());
                        const $editorSection = $("section.new-document-section");

                        // Eliminar la seccion con el editor del contenido una vez nos ha llegado la url de previsualizacion
                        if ($editorSection.length > 0) {
                            $editorSection.remove();
                        }

                        _callInitFunctions();

                    } else {
                        api.getRandomPhotos(that._documentationPublishData.getDocumentTitle(), 1, documentType, _onGetRandomPhoto, true, false);
                    }
                } else {
                    _callInitFunctions();
                }

            }

        }

        // Obtener la portada del documento aleatoria
        function _onGetRandomPhoto(response) {

            if (api.checkisValidResult(response)) {

                // Establecer la portada del documento
                that._documentationPublishData.setDocumentIconUrl(response.result);

                // Si es tipo articulo hay que generar la vista previa y si no ya se puede iniciar la publicacion
                if (documentType === documentationNew.ARTICLE) {

                    const articleHtml = that._documentationPublishData.getArticleDocumentHtml();
                    const articleCover = that._documentationPublishData.getArticleDocumentCover();
                    const articleTitle = that._documentationPublishData.getArticleDocumentTitle();

                    documentationNew.articleDocument.createArticlePreview(articleHtml, articleCover, articleTitle, _onCreatedArticlePreview);

                } else {

                    const $editorSection = $("section.new-document-section");

                    // Eliminar la seccion con el editor del contenido una vez nos ha llegado la url de previsualizacion
                    if ($editorSection.length > 0) {
                        $editorSection.remove();
                    }

                    _callInitFunctions();
                }

            }

        }

        const that = this;
        const documentationNew = documentationScreenController.documentationNew;

        this._documentationPublishData = new DocumentationPublishData();
        this._documentationPublishData.setDocumentType(documentType);
        this._editingPublishedDocument = editPublishedDocument;

        // Cuando sea borrador setear los valores del documento
        if (draft) {
            this._editingDraft = true;
            this._setDraftData(draft);
        }

        // Cuando se le pase la informacion del editor (es por ende tipo ARTICULO y no borrador) setear los datos del articulo
        if (editorData) {
            this._documentationPublishData.setArticleDocumentData(editorData.html, editorData.cover, editorData.title);
            this._documentationPublishData.setDocumentTitle(editorData.title);
            this._titleChanged = true;
        }

        // Cuando se le pase la informacion del documento externo (es por ende tipo EXTERNAL y no borrador) setear los datos del contenido externo
        if (externalContentData) {
            this._documentationPublishData.setExternalContentData(
                externalContentData.url,
                externalContentData.site,
                externalContentData.duration,
                externalContentData.media,
                externalContentData.html,
                externalContentData.card,
                externalContentData.rel,
                externalContentData.thumbnail
            )
            this._documentationPublishData.setDocumentTitle(externalContentData.title || Translator.trans("TR_NUEVO_CONTENIDO_EXTERNO"));
            this._documentationPublishData.setDocumentDescription(externalContentData.description);
            this._titleChanged = true;
        }
        // Asegurar que el usuario esta en la misma pestaña de la documentacion para al finalizar volver a llevarle a la carpeta donde se encontraba
        if (baseController.selectedTabId === this._tabs.LINKS_TAB) {
            this._currentFolderId = documentationScreenController.getCurrentFolder().id
        }

        this._documentationPublishData.setDocumentFileUrl(fileUrl);

        if (!draft) {

            if (externalContentData) {

                api.checkDocumentationLink(externalContentData.url, _onCheckedExternalUrl, false);

            } else if (editorData) {

                that._documentationPublishData.setDocumentIconUrl(editorData.cover);

                const articleHtml = that._documentationPublishData.getArticleDocumentHtml();
                const articleCover = that._documentationPublishData.getArticleDocumentCover();
                const articleTitle = that._documentationPublishData.getArticleDocumentTitle();

                documentationNew.articleDocument.createArticlePreview(articleHtml, articleCover, articleTitle, _onCreatedArticlePreview);

            } else {
                api.getRandomPhotos(this._documentationPublishData.getDocumentTitle(), 1, documentType, _onGetRandomPhoto, true, false);
            }

        } else {
            if (documentType === documentationNew.ARTICLE) {

                const articleHtml = that._documentationPublishData.getArticleDocumentHtml();
                const articleCover = that._documentationPublishData.getArticleDocumentCover();
                const articleTitle = that._documentationPublishData.getArticleDocumentTitle();

                documentationNew.articleDocument.createArticlePreview(articleHtml, articleCover, articleTitle, _onCreatedArticlePreview);

            } else if (documentType === documentationNew.EXTERNAL) {

                api.checkDocumentationLink(that._documentationPublishData.getExternalContentUrl(), _onCheckedExternalUrl);

            } else {
                _callInitFunctions();
            }
        }

    }

    clearData() {

        this._editingDraft = false;
        this._editingPublishedDocument = false;
        this._mediumTitle = null;
        this._folderName = "";
        this._currentFolderId = null;
        this._changedFileOnEdit = false;
        this._titleChanged = false;
        this._articlePreviewUrl = "";
        this._showWithIframe = false;

        this._disableHandlers();

    }

}

